
    import { Component,  Vue } from 'vue-property-decorator';    
    import { IFileTags } from '@/interfaces/Files/IFileTags';    
    import homefilesAPI from '@/store/homepagefileandlinkAPI';
    import Multiselect from 'vue-multiselect'
    @Component({
        components: {
            Multiselect
        }
    })
    export default class Addheaderfile extends Vue {
        private errors = {} as { [id: string]: any };
        private saveErrors = "";
        private filename:string = "";
        private heading:string = "Add File"


        private formValues = {
            file: null,
           
        } as { [id: string]: any }

        private async register() {
           
            try {
                let errors:boolean = false;
                if (this.formValues.file == null && this.filename=="") {
                    alert("This is a required field, please choose a file")
                   // this.saveErrors = "This is a required field, please choose a file";
                    errors = true;
                }
                
                if (!errors) {
                   
                        console.log("edit")
                        //for removig tags
                        
                        //for inserting tags
                        
                        let formData: FormData = new FormData();
                        //if file is null then it won't edit file it will keep th old file
                        formData.append('file', this.formValues.file);
                       

                        formData.append('fileId', this.$route.params.fileId);
                       // console.log(formData)
                        await homefilesAPI.posthomepagefile(formData)
                       // await filesAPI.editfile(this.formValues.file, removeTagTypeSelected, insertTagTypeSelected, this.$route.params.fileId)
                        alert("Editted Successfully");
                        this.$router.push({ path: "/files" });
                    
                    
                }
            }
            catch (error) {
                   // this.saveErrors="Error while adding the file. If the issue persists, please contact us.";
                } finally {
                    // this.saving = false;
           }

        }

        private selectedvalue(result: IFileTags) {
            this.filename = result.file.fileName;
           
            

        }
       
      
            
        }
        
